import { Cookie, XCircle } from 'lucide-react';
import { useCookieStore } from '../store/cookies';

export function CookieConsent() {
  const { hasConsented, setConsent } = useCookieStore();

  if (hasConsented !== null) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-8 md:right-auto md:max-w-md z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-200 dark:border-gray-700">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <Cookie className="w-6 h-6 text-accent" />
          </div>
          <div className="flex-1">
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
              We use cookies to enhance your browsing experience. They help us understand how you interact with our site.
            </p>
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2">
              <button
                onClick={() => setConsent(true)}
                className="px-4 py-2 text-sm font-medium text-white bg-accent-gradient rounded-lg hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-accent/60 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
              >
                Accept the bytes
              </button>
              <button
                onClick={() => setConsent(false)}
                className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
              >
                Decline the crumbs
              </button>
            </div>
          </div>
          <button
            onClick={() => setConsent(false)}
            className="flex-shrink-0 text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
            aria-label="Close cookie consent banner"
          >
            <XCircle className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}